'use client';

import { Divider, Padding, Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';

import { ActivityCard } from '../components/ActivityCard';
import { getIntroContent } from '../introContent';

export const IntroActivitySection = () => {
  const { service } = useDeviceInfo();
  const { activityImages } = getIntroContent(service);

  return (
    <div>
      <Padding x="4" bottom="4">
        <Typography variant="title20pxMed">수익 창출 방법</Typography>
      </Padding>

      <div className="flex flex-col gap-24">
        <ActivityCard
          imageSrc={activityImages.CONTENT01}
          title="1. 큐레이션 샵 링크 공유하기"
          subText="추천하고 싶은 상품을 큐레이션 샵에 전시하고, 내 샵 링크를 SNS에 공유해 보세요."
        />
        <ActivityCard
          imageSrc={activityImages.CONTENT02}
          title="2. 개별 상품 링크 공유하기"
          subText="추천하고 싶은 상품의 링크를 SNS에 공유해 보세요."
        />
      </div>
      <Padding y="8" x="4">
        <Divider variant="line" colorScheme="gray-500" />
      </Padding>
    </div>
  );
};
